import React, { useEffect } from 'react';
import toast, { Toaster as HotToaster } from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheckCircle, faExclamationCircle, } from "@fortawesome/free-solid-svg-icons";
import { ToastTypeEnum, ToastPositionEnum } from '../consts/ToastConst';
import { useSelector } from '../Redux/store';
const FlushToaster = () => {
    const toasterSettings = {
        [ToastTypeEnum.success]: {
            bgColor: 'bg-green-500',
            titleColor: 'text-green-700',
            icon: faCheckCircle,
            duration: 5000
        },
        [ToastTypeEnum.danger]: {
            bgColor: 'bg-toaster-yellow',
            titleColor: 'text-pink-700',
            icon: faExclamationCircle,
            duration: 3000,
        },
        [ToastTypeEnum.warn]: {
            bgColor: 'bg-toaster-yellow',
            titleColor: 'text-yellow-700',
            icon: faCheckCircle,
            duration: 3000,
        },
        [ToastTypeEnum.info]: {
            bgColor: 'bg-blue-500',
            titleColor: 'text-blue-700',
            icon: faCheckCircle,
            duration: 5000
        },
        [ToastTypeEnum.permanent]: {
            bgColor: 'bg-pink-500',
            titleColor: 'text-pink-700',
            icon: faExclamationCircle,
            duration: 20000
        },
    };
    const flushToasterStore = useSelector(state => state.flushToaster.current);
    const handleDelete = () => {
        toast.remove();
    };
    useEffect(() => {
        toast.remove();
        if (flushToasterStore.type !== ToastTypeEnum.none) {
            let position = 'top-center';
            if (flushToasterStore.position === ToastPositionEnum.top) {
                position = 'bottom-center';
            }
            toast.custom(inside(flushToasterStore.type, flushToasterStore.title, flushToasterStore.message), {
                duration: toasterSettings[flushToasterStore.type].duration,
                position: position
            });
        }
    }, [flushToasterStore]);
    const inside = (type, title, message) => {
        if (type === ToastTypeEnum.none) {
            return React.createElement(React.Fragment, null);
        }
        const customClass = (type) => {
            let classes = " text-white ";
            if (type === ToastTypeEnum.danger) {
                classes = " text-haikan-red ";
            }
            else if (type === ToastTypeEnum.warn) {
                classes = " text-black ";
            }
            return classes;
        };
        const setting = toasterSettings[type];
        return (React.createElement("div", { className: "flex justify-between md:w-4/5 -md:w-11/12  mx-auto overflow-hidden rounded-lg shadow-lg bg-opacity-80 bottom-5 sticky z-99999 " + setting.bgColor },
            React.createElement("div", { className: "flex items-center justify-center w-12" },
                React.createElement(FontAwesomeIcon, { icon: setting.icon, className: `w-6 h-6 ${customClass(type)}` })),
            React.createElement("div", { className: `w-full px-4 py-2 -mx-3 h-12 text-white ${customClass(type)}` },
                React.createElement("div", { className: "mx-3 flex items-center h-full" },
                    React.createElement("p", { className: "text-sm " }, message))),
            React.createElement("div", { className: "flex items-center justify-center w-12 cursor-pointer", onClick: handleDelete },
                React.createElement(FontAwesomeIcon, { icon: faTimes, className: `text-2xl text-white ${customClass(type)}` }))));
    };
    return (React.createElement(React.Fragment, null, flushToasterStore.isOnModal ?
        React.createElement(HotToaster, { containerStyle: {
                zIndex: 50000
            } })
        :
            React.createElement(HotToaster, { containerStyle: {
                    zIndex: 5000,
                } })));
};
export default FlushToaster;
